export default __webpack_public_path__ + "static/media/icon-arror.f30825aa.svg";